import { Box, Container, Paper, Typography } from '@mui/material'
import bg from '../../assets/images/photo.png'

const stats = [
  ['Better experience', 'For your customers'],
  ['No extra staff', 'No new hiring required'],
  ['24/7 convenience', 'Fast self-service format'],
  ['New revenue stream', 'Without upfront investment'],
]

export default function WhyItWorks() {
  return (
    <Box sx={{ py: 10 }}>
      <Container maxWidth="lg">
        <Paper
          sx={{
            position: 'relative',
            overflow: 'hidden',
            p: { xs: 3, md: 5 },
            borderRadius: 5,
            backgroundImage: `url(${bg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            border: '1px solid rgba(255,255,255,0.08)',
            color: '#fff',
            minHeight: 420,
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              background:
                'linear-gradient(90deg, rgba(0,0,0,0.78) 0%, rgba(0,0,0,0.58) 45%, rgba(0,0,0,0.35) 100%)',
              zIndex: 1,
            }}
          />

          <Box sx={{ position: 'relative', zIndex: 2 }}>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                gap: 4,
                alignItems: 'center',
              }}
            >
              <Box>
                <Typography variant="overline" sx={{ color: 'rgba(255,255,255,0.65)' }}>
                  Why it works
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 700,
                    mt: 1,
                    mb: 2,
                    maxWidth: 520,
                  }}
                >
                  Turn waiting time into real business value
                </Typography>

                <Typography
                  sx={{
                    color: 'rgba(255,255,255,0.82)',
                    lineHeight: 1.9,
                    maxWidth: 560,
                  }}
                >
                  When customers are already spending time at your location, a modern
                  self-service kiosk gives them something useful to buy while helping
                  you monetize traffic that already exists. No extra team, no complex
                  operations, and no disruption to your business.
                </Typography>
              </Box>

              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                  gap: 2,
                }}
              >
                {stats.map(([title, subtitle]) => (
                  <Paper
                    key={title}
                    sx={{
                      p: 3,
                      borderRadius: 4,
                      background: 'rgba(10,10,10,0.42)',
                      backdropFilter: 'blur(8px)',
                      border: '1px solid rgba(255,255,255,0.12)',
                      color: '#fff',
                      transition: '0.3s ease',
                      boxShadow: '0 10px 30px rgba(0,0,0,0.22)',
                      '&:hover': {
                        transform: 'translateY(-6px)',
                        borderColor: 'rgba(255,255,255,0.22)',
                        boxShadow: '0 16px 40px rgba(0,0,0,0.35)',
                      },
                    }}
                  >
                    <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
                      {title}
                    </Typography>
                    <Typography sx={{ color: 'rgba(255,255,255,0.68)', lineHeight: 1.7 }}>
                      {subtitle}
                    </Typography>
                  </Paper>
                ))}
              </Box>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  )
}